import React from 'react';
import Lottie from 'lottie-react';
import horrorAnimation from './horror.json'; 

const AboutUs = () => {
  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      {/* Animation Section */}
      <div className="flex-1 flex items-center justify-center bg-black p-5">
        <Lottie
          animationData={horrorAnimation}
          loop
          style={{
            width: '100%',
            height: '100%',
            maxWidth: '500px', 
          }}
        />
      </div>

      {/* Text Section */}
      <div className="flex-1 flex items-center justify-center p-5 bg-black text-gray-200">
        <div>
          <h1 className="text-4xl font-bold mb-4 glow-effect">About Us</h1>
          <p className="mb-4">
            Welcome to the **Death Predictor** by Webmafiya! Here, you’ll enter a world where mystery meets technology, blending an eerie atmosphere with deep insights into your health and lifestyle. We’ve crafted this unique experience to bring you spine-tingling fun along with personalized self-discovery.
          </p>
          <p className="mb-4">
  At <a href="https://webmafiya.com" className="text-blue-400 underline">Webmafiya</a>, we bring your vision to life with creative designs and cutting-edge solutions. The Death Predictor blends horror with insight, showcasing our unique approach. For digital strategies, websites, or apps—Webmafiya has you covered.
</p>

          <p>
            Ready to face the unknown? Join us on this adventure and discover what lies beneath. At Webmafiya, we’re all about creating the future together—one bold step at a time.
          </p>
        </div>
      </div>

      <style jsx>{`
        .glow-effect {
          text-shadow: 
            0 0 5px rgba(0, 204, 255, 0.7),
            0 0 10px rgba(0, 204, 255, 0.7),
            0 0 20px rgba(0, 204, 255, 0.7),
            0 0 40px rgba(0, 204, 255, 0.7),
            0 0 80px rgba(0, 204, 255, 0.7);
        }
      `}</style>
    </div>
  );
};

export default AboutUs;
